import React from 'react';
import classNames from 'classnames';

export default function PlusIcon({ className = '' }) {
	return <span className={classNames('icon icon-plus_sign', className)} />;
}
